import { render, staticRenderFns } from "./TransactionFlowPendingList.vue?vue&type=template&id=7542c912&scoped=true&"
import script from "./TransactionFlowPendingList.vue?vue&type=script&lang=js&"
export * from "./TransactionFlowPendingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542c912",
  null
  
)

export default component.exports